import React, { useState } from "react";
import "./erxViewFooter.scss";
import C2CCustomPopup from "../../common/Popups/C2CCustomPopup";
import { Spinner } from "react-bootstrap";

const ERXViewFooter = (props) => {
  const { handleSaveAndPreview, displaySaveTemplate, previewLoader } = props;
  const [saveTemplate, setSaveTemplate] = useState(false);
  // Display UI ===>
  const handelSaveTemplate = () => {
    setSaveTemplate(true);
  };

  const handelcloseSaveTemplate = () => {
    setSaveTemplate(false);
  };
  const displayErxViewFooter = () => {
    return (
      <div className="erx-view-container-footer">
        <div className="erx-view-container-footer-content">
          <div style={{ flex: "1" }}>
            <C2CCustomPopup
              openPopup={saveTemplate} // Use state value to control popup visibility
              popupHeading={<span>Save Template</span>}
              dialogClassName="erx-save-template-popup"
              handleClosePopup={handelcloseSaveTemplate}
            >
              {displaySaveTemplate()}
            </C2CCustomPopup>
          </div>
          <div className="erx-footer-save-button" onClick={handelSaveTemplate}>
            Save Template
          </div>
          {displaySaveAndPreviewPrescription()}
        </div>
      </div>
    );
  };
  const displaySaveAndPreviewPrescription = () => {
    return (
      <div
        className={
          "erx-view-container-save-preview-prescription " +
          (previewLoader ? "erx-preview-btn-cursor" : "")
        }
        onClick={() => (previewLoader ? "" : handleSaveAndPreview("edited"))}
      >
        <div>Preview</div>
        {previewLoader && (
          <div>
            <Spinner animation="border" className="erx-preview-spinner" />
          </div>
        )}
      </div>
    );
  };

  // <===

  return <div className="erx-view-footer">{displayErxViewFooter()}</div>;
};

export default ERXViewFooter;
